import { styled, TableCell, tableCellClasses, TableHead, TableRow } from "@mui/material";
import React from "react";

const TableHeader = ({ columns, showZIndex = true }) => {


  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#E6E9F4",
      color: theme.palette.common.black,
      fontWeight: "600",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
  }));



  return (
    <TableHead>
      <TableRow style={{ backgroundColor: "slategrey" }}>
        {columns.map((title, index) => {
          return (
            <StyledTableCell
              key={index}
              className={`font-bold ${index === 0 ? "text-left" : "text-center"
                }`
              }
            >
              {title}
            </StyledTableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
